import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next';
import { useHistory, Link } from "react-router-dom";
import { useData } from "../../DataContext";
import { get, useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import * as moment from 'moment';
import { Helmet } from "react-helmet";
import { 
    FormControlLabel,
    FormControl,
    Button,
    Box,
    Checkbox,
    Modal,
    Fade,
    Typography
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import './Confirmation.scss'

import { 
    Navbar,
    Header,
    StepHeader,
    FormBox,
    BootstrapInput,
    Footer,
    LoadingSpinner,
} from '../../components/_index'
import VehicleDetail from '../VehicleDetail/VehicleDetail';
import { useYupValidationResolver } from '../../YupValidationResolver';
import ErrorsContainer from '../../components/ErrorsContainer/ErrorsContainer';
import { blobToFile, checkIfRedirect, convertResponseToJson, isEmpty, uploadBlob, uploadFiles, trimRegmark } from '../../utils';
import Scroll from 'react-scroll';
import errorWarning from '../../images/icon_warning.gif'
import { jsPDF } from "jspdf";
import printJS from 'print-js';
import html2canvas from 'html2canvas';

const useStyles = makeStyles((theme) => ({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      width: 360,
    },
}));

export default withTranslation()(function Confirmation({t, i18n}) {
    let scroll = Scroll.animateScroll;
    const classes = useStyles();
    const { setValues, data } = useData();
    const [open, setOpen] = React.useState(false);
    const [ lang, setLang ] = useState('');
    const history = useHistory();
    
    checkIfRedirect(data, history);

    const addressArr = { 
        address: data.address,
        floor: data.floor,
        building: data.building, 
        street: data.street, 
        district: data.district 
    }

    checkForUndefined(addressArr)
    trimRegmark(data.vehicleGp)
    const schema = yup.object().shape({
        agreeDeclaration: yup.boolean().oneOf([true], t("errors.frontend.790-E-0801")),
    })

    const { 
        register,
        control,
        handleSubmit, 
        errors,
        watch,
        clearErrors,
        getValues,
    } = useForm({
        defaultValues: { 
            agreeDeclaration: !!data.agreeDeclaration
        },
        mode: "onSubmit",
        resolver: useYupValidationResolver(schema),
    });

    const number = Math.floor(Math.random()*9999999);
    const agreeDeclarationWatch = watch('agreeDeclaration');
    const handleOpen = () => {
        setOpen(true);
    };
    const onSubmit = (data) => {
        console.log(data, 'API triggered');
        // history.push("./makePayment");
        insertData();
        setValues(data);
    };
    const onError = (errors) => {
        scroll.scrollToTop();
    }

    useEffect(() => {
        scroll.scrollToTop();
    }, []);

    let [ customError, setCustomError ] = useState({});

    const summaryText = ()=>{
        var pdf = new jsPDF('', 'pt', 'a4');
        var element = document.getElementById("ConfirmationForm");   // 这个dom元素是要导出pdf的div容器
        var w = element.offsetWidth;    // 获得该容器的宽
        var h = element.offsetHeight;    // 获得该容器的高
        var offsetTop = element.offsetTop;    // 获得该容器到文档顶部的距离
        var offsetLeft = element.offsetLeft;    // 获得该容器到文档最左的距离
        var canvas = document.createElement("canvas");
        var abs = 0;
        var win_i = window.innerWidth;    // 获得当前可视窗口的宽度（不包含滚动条）
        var win_o = window.innerWidth;    // 获得当前窗口的宽度（包含滚动条）
        if(win_o>win_i){
            abs = (win_o - win_i)/2;    // 获得滚动条长度的一半
        }
        canvas.width = w * 2;    // 将画布宽&&高放大两倍
        canvas.height = h * 2;
        var context = canvas.getContext("2d");
        context.scale(2, 2);
        context.translate(-offsetLeft-abs,-offsetTop);    
        // 这里默认横向没有滚动条的情况，因为offset.left(),有无滚动条的时候存在差值，因此        
        // translate的时候，要把这个差值去掉
        return html2canvas(element).then(function(canvas) {
            var contentWidth = canvas.width;
            var contentHeight = canvas.height;
            //一页pdf显示html页面生成的canvas高度;
            var pageHeight = contentWidth / 592.28 * 841.89;
            //未生成pdf的html页面高度
            var leftHeight = contentHeight;
            //页面偏移
            var position = 0;
            //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
            var imgWidth = 595.28;
            var imgHeight = 592.28/contentWidth * contentHeight;

            var pageData = canvas.toDataURL('image/jpeg', 1.0);

            //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
            //当内容未超过pdf一页显示的范围，无需分页
            if (leftHeight < pageHeight) {
            pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
            } else {    // 分页
                while(leftHeight > 0) {
                    pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
                    leftHeight -= pageHeight;
                    position -= 841.89;
                    //避免添加空白页
                    if(leftHeight > 0) {
                    pdf.addPage();
                    }
                }
            }  
            return pdf    
        })
    }

    const summaryImageURL = async ()=>{
        var element = document.getElementById("ConfirmationForm");   // 这个dom元素是要导出pdf的div容器
        var w = element.offsetWidth;    // 获得该容器的宽
        var h = element.offsetHeight;    // 获得该容器的高
        var offsetTop = element.offsetTop;    // 获得该容器到文档顶部的距离
        var offsetLeft = element.offsetLeft;    // 获得该容器到文档最左的距离
        var canvas = document.createElement("canvas");
        var abs = 0;
        var win_i = window.innerWidth;    // 获得当前可视窗口的宽度（不包含滚动条）
        var win_o = window.innerWidth;    // 获得当前窗口的宽度（包含滚动条）
        if(win_o>win_i){
            abs = (win_o - win_i)/2;    // 获得滚动条长度的一半
        }
        canvas.width = w * 2;    // 将画布宽&&高放大两倍
        canvas.height = h * 2;
        var context = canvas.getContext("2d");
        context.scale(2, 2);
        context.translate(-offsetLeft-abs,-offsetTop);    
        // 这里默认横向没有滚动条的情况，因为offset.left(),有无滚动条的时候存在差值，因此        
        // translate的时候，要把这个差值去掉
        const url = html2canvas(element).then(function(canvas) {
            return canvas.toDataURL('image/jpeg', 1.0)
        })

        return url;
    }

    const dataURLToFile = (dataurl)=>{
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1]
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {type:mime});
    }

    const getSummaryText = () => {
        let textArray = [t("confirmation.particularsApplicant.title")];
        if(data.applicantType === 'Personal'){
            textArray = textArray.concat([
                t('confirmation.particularsApplicant.applicantDetail'),
                `${t('confirmation.particularsApplicant.titleField')}\r\n${t('step2.personalInfo.titleInfo.'+data.personalTitle)}`,
                `${t('confirmation.particularsApplicant.firstName')}\r\n${data.firstName}`,
            ]);
        } else if (data.applicantType === 'Company') {
            textArray = textArray.concat([
                `${t('confirmation.particularsApplicant.companyName')}\r\n${data.companyName}`
            ]);
        } else {
            textArray = textArray.concat([
                `${t('step2.governmentInfo.department')}\r\n${data.department}`
            ]);
        }
        textArray = textArray.concat([
            `${t('confirmation.particularsApplicant.contactTitle')}\r\n${t('step2.personalInfo.titleInfo.'+data.contactTitle)}`,
            `${t('confirmation.particularsApplicant.contactPerson')}\r\n${data.contactPerson}`,
            `${t('confirmation.particularsApplicant.telNo')}\r\n${data.telNo}`,
            `${t('confirmation.particularsApplicant.faxNo')}\r\n${isEmpty(data.faxNo) ? "" : data.faxNo }`,
            `${t('confirmation.particularsApplicant.email')}\r\n${data.email}`
        ]);
        if(data.applicantType === 'Personal'||data.applicantType === 'Company'){
            const addressText = t('confirmation.particularsApplicant.address') + "\r\n"
            + `${t('step2.contactInfo.flatRm')}:${data.address}\r\n`
            + `${t('step2.contactInfo.floor')}:${data.floor}\r\n`
            + `${t('step2.contactInfo.building')}:${data.building}\r\n`
            + `${t('step2.contactInfo.street')}:${data.street}\r\n`
            + `${t('step2.contactInfo.district')}:${t(`step3.location.${data.district.split(' ').reduce((a,b)=>a.concat('_', b))}`)}\r\n`;

            textArray = textArray.concat([
                addressText,
                `${t('confirmation.particularsApplicant.applicationReason')}\r\n${data.applicationReason}`,
                t("confirmation.applicationDetail.title"),
                t('confirmation.applicationDetail.location')
            ]);
        }
        
        const locationText = data.locationGp.reduce((text, location, index) => {
            const trueArr = location.permitType.filter(item => item.selected === true);
            return (text
            +[
                `${index+1}. ${t('confirmation.applicationDetail.address')}\r\n${location.streetNo + ' ' +  location.streetName +', ' + districtName(location.district).toUpperCase() }`,
                `${t('confirmation.applicationDetail.permitType')}\r\n${trueArr.map((value,key)=>(key==0?t(`step3.location.permitTypeOpt.${value.id}`):(', '+t(`step3.location.permitTypeOpt.${value.id}`))))}`,
                `${t('confirmation.applicationDetail.remark')}\r\n${location.remarks}`
            ].join("\r\n\r\n"))}, "");
        textArray = textArray.concat([
            locationText,
            t('confirmation.applicationDetail.vehicle')
        ]);
        const vehicleText = data.vehicleGp.reduce((text, vehicle, index) => {
            return (text
                +[
                    `${index+1}. ${t('confirmation.applicationDetail.vehicleRegNo')}\r\n${vehicle.vehicleRegNo.toUpperCase()}`,
                    `${t('confirmation.applicationDetail.issueDate') + " (YYYY-MM-DD)"}\r\n${moment(vehicle.issueDate).format('YYYY-MM-DD')}`
                ].join("\r\n\r\n"))
        }, "");
        textArray = textArray.concat([
            vehicleText,
            t('confirmation.applicationDetail.dateTime')
        ]);
        const dateTimeText = data.dateTimeGp.reduce((text, dateTime, index) => {
            return (text
                +[
                    `${index+1}. ${t('confirmation.applicationDetail.date')}\r\n${moment(dateTime.startDate).format('YYYY-MM-DD') + ' - ' + moment(dateTime.endDate).format('YYYY-MM-DD')}`,
                    `${t('confirmation.applicationDetail.time')}\r\n${dateTime.startTime + ' - ' + dateTime.endTime}`,
                    `${t('confirmation.applicationDetail.recurrence')}\r\n${dateTime.recurrence.filter((rec)=>(rec.selected)).map((rec)=>(t(rec.name))).join(", ")}`
                ].join("\r\n\r\n"))
        }, "");
        textArray = textArray.concat([
            dateTimeText,
            t('confirmation.applicationDetail.reviewApplication'),
            `${t('confirmation.applicationDetail.permitApplied')}\r\n${permitToBeApplied(data.iWant)}`,
            t('confirmation.applicationDetail.supportDoc'),
            data?.endorseFiles?.length>0?`${t('confirmation.applicationDetail.indicateDocOpt1')}\r\n${checkFiles(data.endorseFiles)}`:'',
            data?.otherFiles?.length>0?`${t('confirmation.applicationDetail.indicateDocOpt2')}\r\n${checkFiles(data.otherFiles)}`:'',
            t('confirmation.applicationDetail.permitCollection'),
            `${t('confirmation.applicationDetail.collectMethod')}\r\n${collectMethod(data.collectMethod, data.iWant)}`
        ]);

        return textArray.join("\r\n\r\n");
    }

    const insertData = async () => {
        let preferredLang = 'english';
        switch (i18n.language){
            case "tc":
                preferredLang = 'chinese';
                break;
            case "sc":
                preferredLang = 'sChinese';
                break;
            default:
            case "en":
                preferredLang = 'english';
                break;
        }
        var url = window.location.origin + '/EPASService/application/insertSubmittedData'
        
        const summaryText = getSummaryText();
        const summaryFile = new Blob([summaryText], {type: "text/plain"});
        const uploadFilesResult = await uploadBlob(summaryFile, "E-Form Summary.txt");
        if(!isEmpty(uploadFilesResult)){
            setValues({endorseFilesId: [...data.endorseFilesId, ...uploadFilesResult]});
        }else{
            return false
        }
		var dataString = JSON.stringify({...data, endorseFilesId: [...data.endorseFilesId, ...uploadFilesResult], preferredLang, dateTimeGp: data.dateTimeGp.map(({startDate, endDate, ...rest})=>({...rest, startDate: moment(startDate).format("YYYY-MM-DDT00:00:00.000[Z]"), endDate: moment(endDate).format("YYYY-MM-DDT00:00:00.000[Z]")}))});
        
		fetch(url, {
  			method: 'POST', // or 'PUT'
  			body: dataString,//data, // data can be `string` or {object}!
	        // mode: 'no-cors',
 			contentType: "application/json"
		}).catch(function(){console.log('error')})
        .then((response) => (convertResponseToJson(response)))
        .then((jsonObj)=>{
            if(jsonObj.error){
                console.log("insert data error: ", jsonObj);
                setCustomError({networkError: {message: t("errors.frontend.790-E-0900")}});
                scroll.scrollToTop();
            } else {
                console.log("jsonObj.data: ", jsonObj.data);
                if(jsonObj.data.email){
                    let { email, ...rest } = jsonObj.data;
                    setValues({ ...rest, emailStatus: email });
                } else {
                    setValues(jsonObj.data);
                }
                history.push(`${process.env.REACT_APP_SUB_ROUTE}/submitSuccess`);
            }
        });
    }
    
    const handleBack = () => {
        history.push(`${process.env.REACT_APP_SUB_ROUTE}/applicationDetail`);
    }

    function permitToBeApplied(iWant) {
        let permitNo = iWant;
        switch (permitNo) {
            case 'one':
                return ( t('step3.reviewApplication.iWantOpt1') );
            case 'bulk':
                return (
                    <>
                        <Typography variant="body1" className="bold">
                            {t('step3.reviewApplication.iWantOpt2')} : {data.numPermit}
                        </Typography>
                    </>
                )
            case 'others':
                
                return (
                    <>
                        {t('step3.reviewApplication.iWantOpt3')}
                        <br/><br/>
                        <Typography variant="body1">
                            {t('confirmation.applicationDetail.remark')}
                        </Typography>
                        <Typography variant="body1" className="bold textwrap">
                            {data.remarks}
                        </Typography>
                    </>
                );
            default:
                console.log('error');
        }
    }
    // Temporary solution until a better one available
    function districtName(districtName) {
        switch (districtName) {
            case 'Central and Western':
                return (t('step3.location.Central_and_Western'));
            case 'Eastern':
                return (t('step3.location.Eastern'));
            case 'Southern':
                return (t('step3.location.Southern'));
            case 'Wan Chai':
                return (t('step3.location.Wan_Chai'));
            case 'Sham Shui Po':
                return (t('step3.location.Sham_Shui_Po'));
            case 'Kowloon City':
                return (t('step3.location.Kowloon_City'));
            case 'Kwun Tong':
                return (t('step3.location.Kwun_Tong'));
            case 'Wong Tai Sin':
                return (t('step3.location.Wong_Tai_Sin'));
            case 'Yau Tsim Mong':
                return (t('step3.location.Yau_Tsim_Mong'));
            case 'Islands':
                return (t('step3.location.Islands'));
            case 'Kwai Tsing':
                return (t('step3.location.Kwai_Tsing'));
            case 'North':
                return (t('step3.location.North'));
            case 'Sai Kung':
                return (t('step3.location.Sai_Kung'));
            case 'Sha Tin':
                return (t('step3.location.Sha_Tin'));
            case 'Tai Po':
                return (t('step3.location.Tai_Po'));
            case 'Tsuen Wan':
                return (t('step3.location.Tsuen_Wan'));
            case 'Tuen Mun':
                return (t('step3.location.Tuen_Mun'));
            case 'Yuen Long':
                return (t('step3.location.Yuen_Long'));
        }
    }

    function collectMethod(collectMethod, iWant) {
        let method = collectMethod;

        if (iWant === 'one') {
            switch (method) {
                case 'post':
                    return (t('confirmation.collectMethod.post'));
                case 'e-Print':
                    return (t('confirmation.collectMethod.ePrint'));
                default:
                    console.log('error');
            }
        }
        else { return (t('confirmation.collectMethod.post'))}
    }

    
    function checkForUndefined(arr) {
        let check = (Object.values(arr)).includes(undefined)
        return check
    }
    
    function checkFiles(fileArr) {
        let arr = [];
        let arrLength = fileArr.length - 1

        return fileArr.map((item, index) => {
            console.log(item)
            if (index != arrLength) {
                return (item.name + ', ')
            } else {
                return (item.name)
            }
        })
    }

    function recurrenceCheck(dateTimeGp) {
        // (dateTimeGp) 
        const multipleTrue = dateTimeGp.recurrence.filter(recurrence => recurrence.selected == true)
        if (multipleTrue.length > 1) {
            let arrLength = multipleTrue.length - 1

            return multipleTrue.map((item, index) => {
                if (index != arrLength) {
                    // console.log(index, arrLength)
                    return (
                        <Typography variant="body1" className="bold">
                           {t('step3.dateTime.' + item.id) + ','}&nbsp;
                           {console.log("ids:", item.id)}
                        </Typography>
                    )
                } else {
                    return (
                        <Typography variant="body1" className="bold">
                            {t('step3.dateTime.' + item.id)}
                            {console.log("id:", item.id)}
                        </Typography>
                    )
                }
            })
        } else {
            console.log("multipleTrue", multipleTrue)
            return (
                <Typography variant="body1" className="bold">
                    {t('step3.dateTime.' + multipleTrue[0].id)}
                </Typography>
            )
        }
    }

    function firstLetterUpperCase(string) {
        let firstLetter = string.slice(0,1);
        let toUpperCaseFirstLetter = firstLetter.toUpperCase();

        return (toUpperCaseFirstLetter + string.slice(1))
    }
    console.log('data: ',data)
    
    const [dnsData, setDnsData] = useState(null);

    const getDnsData = async () => {
    const response = await fetch(`https://dns.google.com/resolve?name=` + window.location.hostname + `&type=1`);
    const jsonData = await response.json();
        return jsonData;
    };

    useEffect(() => {
        getDnsData().then(data => {
        setDnsData(data);
        }); 
    }, []);

    if (dnsData === null) {
        return null;
    }
    
    const siteID = () => {
        console.log("DNS Status Code: ", dnsData.Status);
        if (dnsData.Status.toString() === "0") {
            if(dnsData.Answer[0].data.toString() === "202.128.244.150") {
                console.log(">>> UAT <<<");
                return "0";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.229.85") {
                console.log(">>> KP Server <<<");
                return "1";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.244.85") {
                console.log(">>> SP Server <<<");
                return "2";
            }
            else if (dnsData.Answer[0].name.toString() === "epas.td.gov.hk.") {
                if (dnsData.Answer[1].data.toString() === "202.128.229.85") {
                    console.log(">>> KP Server <<<");
                    return "1";
                }
                else if (dnsData.Answer[1].data.toString() === "202.128.244.85") {
                    console.log(">>> SP Server <<<");
                    return "2";
                }
            }
        }
        else {
            console.log(">>> Localhost <<<");
            return "0";
        }
    }
    
    console.log("<><>Site ID:<><>:", data.siteIDNumber);

    return (
        <main>
            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={open}
                >
                    <Fade in={open}>
                    <div className={classes.paper}>
                        <LoadingSpinner />
                        <h2 id="transition-modal-title" className="center">{t('confirmation.modalMessage.submission')}</h2>
                        <h2 id="transition-modal-description"  className="center">{t('confirmation.modalMessage.wait')}</h2>
                    </div>
                    </Fade>
                </Modal>
            </div>
            <Helmet>
                <title>{`Screen ID: SC-790-`+siteID()+'-009'}</title>
            </Helmet>
            <Box className="wrapper confirmation">
                <Header onLangChange={setLang} langLock="langLocked" />
                <Box className="mainWrapper">
                    <Navbar step="step4"/>
                    <Box className="contentWrapper">
                        <ErrorsContainer errors={{ ...errors, ...customError }} />
                        <StepHeader 
                            step="common.step4" 
                            title="common.step3Title"
                            mandatory
                        />
                        <form onSubmit={handleSubmit(onSubmit, onError)} noValidate id="ConfirmationForm">
                            <FormBox header="confirmation.particularsApplicant.title">
                                <Box p={5}>
                                    { (data.applicantType === 'Personal') ? (
                                            <>
                                                <Box mb={6}>
                                                    <Typography variant="body1">
                                                        {t('confirmation.particularsApplicant.applicantDetail')} 
                                                    </Typography>
                                                </Box>
                                                <Box mb={6}>
                                                    <Typography variant="body1">
                                                        {t('confirmation.particularsApplicant.titleField')}<Box component="span" className="danger">*</Box>
                                                    </Typography>
                                                    <Typography variant="body1" className="bold">
                                                        {t('step2.personalInfo.titleInfo.'+data.personalTitle)}
                                                    </Typography>
                                                </Box>
                                                <Box mb={6}>
                                                    <Typography variant="body1">
                                                        {t('confirmation.particularsApplicant.firstName')}<Box component="span" className="danger">*</Box>
                                                    </Typography>
                                                    <Typography variant="body1" className="bold">
                                                        {/* Tai Man */}
                                                        {data.firstName}
                                                    </Typography>
                                                </Box>
                                                <br />
                                            </>
                                        ) : (data.applicantType === 'Company') ? 
                                        (
                                            <>
                                                <Box mb={6}>
                                                    <Typography variant="body1">
                                                        {t('confirmation.particularsApplicant.companyName')}<Box component="span" className="danger">*</Box>
                                                    </Typography>
                                                    <Typography variant="body1" className="bold textwrap">
                                                        {data.companyName}
                                                    </Typography>
                                                </Box>
                                            </>
                                        ) : 
                                        (
                                            <>
                                                <Box mb={6}>
                                                    <Typography variant="body1">
                                                        {t('step2.governmentInfo.department')}<Box component="span" className="danger">*</Box>
                                                    </Typography>
                                                    <Typography variant="body1" className="bold textwrap">
                                                        {data.department}
                                                    </Typography>
                                                </Box>
                                            </>
                                        )
                                    }
                                    <Box mb={6}>
                                        <Typography variant="body1">
                                            {t('confirmation.particularsApplicant.contactTitle')}<Box component="span" className="danger">*</Box>
                                        </Typography>
                                        <Typography variant="body1" className="bold">
                                            {/* Chan Tai Man */}
                                            {t('step2.personalInfo.titleInfo.'+data.contactTitle)}
                                        </Typography>
                                    </Box>
                                    <Box mb={6}>
                                        <Typography variant="body1" className="underline">
                                            {t('confirmation.particularsApplicant.contactPerson')}<Box component="span" className="danger">*</Box>
                                        </Typography>
                                        <Typography variant="body1" className="bold">
                                            {/* Chan Tai Man */}
                                            {data.contactPerson}
                                        </Typography>
                                    </Box>
                                    <Box mb={6}>
                                        <Typography variant="body1">
                                            {t('confirmation.particularsApplicant.telNo')}<Box component="span" className="danger">*</Box>
                                        </Typography>
                                        <Typography variant="body1" className="bold">
                                            {/* +852 2345 5678 */}
                                            {data.telNo}
                                        </Typography>
                                    </Box>
                                    <Box mb={6}>
                                        <Typography variant="body1">
                                            {t('confirmation.particularsApplicant.faxNo')}
                                        </Typography>
                                        <Typography variant="body1" className="bold">
                                            {/* 2345 6789 */}
                                            {isEmpty(data.faxNo) ? <>&nbsp;</> : data.faxNo }
                                        </Typography>
                                    </Box>
                                    <Box mb={6}>
                                        <Typography variant="body1">
                                            {t('confirmation.particularsApplicant.email')}<Box component="span" className="danger">*</Box>
                                        </Typography>
                                        <Typography variant="body1" className="bold">
                                            {/* example@mail.com.hk */}
                                            {data.email}
                                        </Typography>
                                    </Box>
                                    {/* <Box mb={6}>
                                        <Typography variant="body1">
                                            {t('confirmation.particularsApplicant.reenterEmail')}
                                        </Typography>
                                        <Typography variant="body1" className="bold">
                                            {/* example@mail.com.hk */}
                                            {/* {data.reenterEmail} */}
                                        {/* </Typography>
                                    </Box>  */}
                                    {data.applicantType !== 'Government' &&
                                        <Box mb={6}>
                                            <Typography variant="body1">
                                                {t('confirmation.particularsApplicant.address')}<Box component="span" className="danger">*</Box>
                                            </Typography>
                                            { ( addressArr && (checkForUndefined(addressArr) == false) ) &&  
                                                (
                                                    <Typography variant="body1" className="bold">
                                                        {/* Suite 1803 <br />
                                                        18/F <br />
                                                        Langham Place Office Tower <br />
                                                        8 Argyle St <br />
                                                        Mong Kok <br /> */}
                                                        <div><span className="label italic">{t('step2.contactInfo.flatRm')}: </span>{data.address}</div>
                                                        <div><span className="label italic">{t('step2.contactInfo.floor')}: </span>{data.floor}</div>
                                                        <div><span className="label italic">{t('step2.contactInfo.building')}: </span>{data.building}</div>
                                                        <div><span className="label italic">{t('step2.contactInfo.street')}: </span>{data.street}</div>
                                                        <div><span className="label italic">{t('step2.contactInfo.district')}: </span>{t(`step3.location.${data.district.split(' ').reduce((a,b)=>a.concat('_', b))}`)}</div>
                                                    </Typography>
                                                )
                                            }
                                        </Box>
                                    }
                                    <Box mb={6}>
                                        <Typography variant="body1">
                                            {t('confirmation.particularsApplicant.applicationReason')}<Box component="span" className="danger">*</Box>
                                        </Typography>
                                        <Typography variant="body1" className="bold textwrap">
                                            {/* New Application */}
                                            {data.applicationReason}
                                        </Typography>
                                    </Box>
                                </Box>
                            </FormBox>
                            <FormBox header="confirmation.applicationDetail.title">
                                <Box p={5}>
                                    <Box mb={12}>
                                        <Typography variant="h6">
                                            {t('confirmation.applicationDetail.location')}
                                        </Typography>
                                        <ol>
                                            { data.locationGp && data.locationGp.map((i) => {
                                                const trueArr = i.permitType.filter(item => item.selected == true)
                                                console.log("trueArr: ", trueArr);
                                                return (
                                                    <li key={i.id}>
                                                        <Box display="flex">
                                                            <Typography variant="body1">
                                                                {t('confirmation.applicationDetail.address')}<Box component="span" className="danger">*</Box>
                                                            </Typography>
                                                            <Typography variant="body1" className="bold">
                                                                &nbsp;
                                                                {i.streetNo + ' ' +  i.streetName +', ' + districtName(i.district).toUpperCase() }
                                                            </Typography>
                                                        </Box>

                                                        <Box display="flex" key={i.id}>
                                                            <Typography variant="body1">
                                                                {t('confirmation.applicationDetail.permitType')}<Box component="span" className="danger">*</Box>
                                                            </Typography>
                                                            <Typography variant="body1" className="bold">
                                                                &nbsp;
                                                                {trueArr.map((value,key)=>(key==0?t(`step3.location.permitTypeOpt.${value.id}`):(', '+t(`step3.location.permitTypeOpt.${value.id}`))))}
                                                            </Typography>
                                                        </Box>
                                                        
                                                        <Box display="block">
                                                            <Typography variant="body1">
                                                                {t('confirmation.applicationDetail.remark')}
                                                            </Typography>
                                                            <Typography variant="body1" className="bold textwrap">
                                                                {i.remarks}
                                                            </Typography>
                                                        </Box>
                                                    </li>
                                                );
                                            }) } 
                                        </ol>
                                    </Box>
                                    <Box mb={12}>
                                        <Typography variant="h6">
                                            {t('confirmation.applicationDetail.vehicle')}
                                        </Typography>
                                        <ol>
                                            { 
                                                data.vehicleGp && data.vehicleGp.map((index) => {
                                                    return (
                                                        <li 
                                                            key={index}
                                                        >
                                                            <Box display="flex">
                                                                <Typography variant="body1">
                                                                    {t('confirmation.applicationDetail.vehicleRegNo')}<Box component="span" className="danger">*</Box>
                                                                </Typography>
                                                                <Typography variant="body1" className="bold">
                                                                    &nbsp;
                                                                    {index.vehicleRegNo.toUpperCase()}
                                                                </Typography>
                                                            </Box>
                                                            <Box display="flex">
                                                                <Typography variant="body1">
                                                                    {t('confirmation.applicationDetail.issueDate') + " (YYYY-MM-DD)"}<Box component="span" className="danger">*</Box>
                                                                </Typography>
                                                                <Typography variant="body1" className="bold">
                                                                    &nbsp;
                                                                    {index.issueDate==null?"---":moment(index.issueDate).format('YYYY-MM-DD')}
                                                                </Typography>
                                                            </Box>
                                                        </li>
                                                    );
                                                })
                                            }
                                        </ol>
                                    </Box>
                                    <Box mb={12}>
                                        <Typography variant="h6">
                                            {t('confirmation.applicationDetail.dateTime')}
                                        </Typography>
                                        <ol>
                                            { 
                                                data.dateTimeGp && data.dateTimeGp.map((dateTimeGp) => {
                                                    return (
                                                        <li
                                                            key={dateTimeGp} 
                                                        >
                                                            <Box display="flex">
                                                                <Typography variant="body1">
                                                                    {t('confirmation.applicationDetail.date')}<Box component="span" className="danger">*</Box>
                                                                </Typography>
                                                                <Typography variant="body1" className="bold">
                                                                    &nbsp;
                                                                    {moment(dateTimeGp.startDate).format('YYYY-MM-DD') + ' - ' + moment(dateTimeGp.endDate).format('YYYY-MM-DD')}
                                                                </Typography>
                                                            </Box>
                                                            <Box display="flex">
                                                                <Typography variant="body1">
                                                                    {t('confirmation.applicationDetail.time')}<Box component="span" className="danger">*</Box>
                                                                </Typography>
                                                                <Typography variant="body1" className="bold">
                                                                    &nbsp;
                                                                    {dateTimeGp.startTime + ' - ' + dateTimeGp.endTime}
                                                                </Typography>
                                                            </Box>     
                                                            <Box display="flex" flexWrap="wrap">
                                                                <Typography variant="body1">
                                                                    {t('confirmation.applicationDetail.recurrence')}<Box component="span" className="danger">*</Box>
                                                                </Typography>
                                                                &nbsp;
                                                                { recurrenceCheck(dateTimeGp) }
                                                                {console.log("dateTimeGp.recurrence", dateTimeGp.recurrence)}
                                                            </Box>       
                                                        </li>
                                                    );
                                                })
                                            }
                                        </ol>
                                    </Box>
                                    <Box mb={12}>
                                        <Typography variant="h6">
                                            {t('confirmation.applicationDetail.reviewApplication')}
                                        </Typography>
                                        <Box mb={6}>
                                            <Typography variant="body1">
                                                {t('confirmation.applicationDetail.permitApplied')}<Box component="span" className="danger">*</Box>
                                            </Typography>
                                            <Typography variant="body1" className="bold">
                                                &nbsp;
                                                { permitToBeApplied(data.iWant) }
                                                {/* One permit for each vehicle */}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box mb={12}>
                                        <Typography variant="h6">
                                            {t('confirmation.applicationDetail.supportDoc')}
                                        </Typography>
                                        &nbsp;
                                        {data?.endorseFiles?.length>0 && <Box mb={6}>
                                            <Typography variant="body1">
                                                {t('confirmation.applicationDetail.indicateDocOpt1')}<Box component="span" className="danger">*</Box>
                                            </Typography>
                                            <Typography variant="body1" className="bold">
                                                { checkFiles(data.endorseFiles) }
                                            </Typography>
                                        </Box> }
                                        {data?.otherFiles?.length>0 && <Box mb={6}>
                                            <Typography variant="body1">
                                                {t('confirmation.applicationDetail.indicateDocOpt2')}<Box component="span" className="danger">*</Box>
                                            </Typography>
                                            <Typography variant="body1" className="bold">
                                                { checkFiles(data.otherFiles) }
                                            </Typography>
                                        </Box> }
                                    </Box>
                                    <Box mb={12}>
                                        <Typography variant="h6">
                                            {t('confirmation.applicationDetail.permitCollection')}
                                        </Typography>
                                        {/* <Box mb={6}>
                                            <Typography variant="body1">
                                                {t('confirmation.applicationDetail.preferredLang')}
                                            </Typography>
                                            <Typography variant="body1" className="bold">
                                                English
                                            </Typography>
                                        </Box> */}
                                        <Box mb={6}>
                                            <Typography variant="body1">
                                                {t('confirmation.applicationDetail.collectMethod')}<Box component="span" className="danger">*</Box>
                                            </Typography>
                                            <Typography variant="body1" className="bold">
                                                {/* Post */}
                                                { collectMethod(data.collectMethod, data.iWant) }
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </FormBox>
                            <FormBox header2="confirmation.declaration.title">
                                <Box p={5}>
                                    <div class="danger bold">
                                        <ol>
                                            <li>
                                                <Box mb={6}>
                                                    <Typography variant="body1">
                                                        {t('confirmation.declaration.msg1')}
                                                    </Typography>
                                                </Box>
                                            </li>
                                            <li>
                                                <Box mb={6}>
                                                    <Typography variant="body1">
                                                        {t('confirmation.declaration.msg2')}
                                                    </Typography>
                                                </Box>
                                            </li>
                                            <li>
                                                <Box mb={6}>
                                                    <Typography variant="body1">
                                                        {t('confirmation.declaration.msg3')}
                                                    </Typography>
                                                </Box>
                                            </li>
                                        </ol>
                                    </div>
                                </Box>
                            </FormBox>
                            <FormBox>
                                <Box p={5}>
                                    <FormControl
                                        error={!!errors.agreeDeclaration}
                                        required 
                                    >
                                        <Controller
                                            control={control}
                                            id="agreeDeclaration"
                                            name="agreeDeclaration"
                                            render={(props) =>
                                                <label className="MuiFormControlLabel-root">
                                                    <Checkbox 
                                                        checked={props.value}
                                                        color="primary"   
                                                        onChange={(e) =>{
                                                            props.onChange(e.target.checked);
                                                        }}
                                                    />
                                                    <span>{t('confirmation.agreement.agreeDeclaration')}</span>
                                                </label>
                                            }
                                            defaultValue={data.agreeDeclaration}
                                        />
                                        {!!errors.agreeDeclaration ? <img id="agreeDeclaration_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                    </FormControl>
                                </Box>
                            </FormBox>
                            <FormBox>
                                <Box
                                    display="flex" 
                                    justifyContent="flex-end"
                                >
                                    <Button 
                                        variant="contained" 
                                        color="secondary" 
                                        className="secBtn"
                                        onClick={handleBack}
                                    >
                                        {t('common.button.back')}
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        color="primary"
                                        onClick={agreeDeclarationWatch ? handleOpen : ""} 
                                        type="submit"
                                    >
                                        {t('common.button.submit')}
                                    </Button>
                                </Box>
                            </FormBox>
                        </form>
                    </Box>
                </Box>
            </Box>
            <Footer />
        </main>
    )
})
